import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { Team } from '@/lib/models/Team'

@Module
export class PageURLTeam extends VuexModule {
    public team: Team = new Team()

    @Mutation
    public updateTeam (team: Team) {
      this.team = team
    }

    @Action({ commit: 'updateTeam', rawError: true })
    public async loadTeam (teamId?: number) {
      if (!teamId) {
        const urlParams = new URLSearchParams(window.location.search)
        teamId = parseInt(urlParams.get('tid') ?? '0')
      }
      if (!this.team.id || this.team.id !== teamId) {
        return await Team.getWithMembers(teamId)
      } else {
        return this.team
      }
    }

    @Action({ commit: 'updateTeam', rawError: true })
    public async forceLoadTeam (teamId?: number) {
      if (!teamId) {
        const urlParams = new URLSearchParams(window.location.search)
        teamId = parseInt(urlParams.get('tid') ?? '0')
      }
      return await Team.getWithMembers(teamId)
    }
}
